import script from "./c-preview.vue?vue&type=script&lang=tsx&setup=true"
export * from "./c-preview.vue?vue&type=script&lang=tsx&setup=true"

import "./c-preview.vue?vue&type=style&index=0&id=50b59948&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b59948"]])

export default __exports__